import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  View,
  Text,
  StyleSheet,
} from "react-native";
import Width from "../../../assets/Width";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import {globalConfigurableData, globalConst} from "../../../utils/globalConstant";
import { Network } from "../../../utils/network";
import Colors from "../../../assets/Color/Colors";
import {isMobile} from "../../../utils/commonMethods";
import TitleComponent from "./TitleComponent";
import {globalFormStyle} from "../../../assets/GlobalStyle/globalFormStyle";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {useNavigation} from "@react-navigation/native";
import {INDIA} from "../../../utils/constants";
import {useSelector} from "react-redux";
import {Button} from "../../../components/core/Button";
import {Input} from "../../../components/core/Input";

const AddLiquidity = ({
  eventDetails,
  orderStatus,
  onBottomSheetClose,
  closeSheet,
}) => {
  const navigation = useNavigation();
  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    reset,
    watch,
    setError,
    clearErrors,
  } = useForm({mode: 'onChange'});
  const [liq, setLiq] = useState({
    liquidityShares: 0,
    shares: 0,
    positionType: '',
    liquidityTokenPrice: 0,
  });

  let userInfo = useSelector(({ profile }) => profile.profileData);
  const watchshare = watch("currentShare");

  useEffect(() => {
    reset({
      currentShare: '1000',
    });
  }, []);
  useEffect(() => {
    watchshare && getTotalAmountRecieve();
  }, [watchshare]);

  const prefix = 'prefix-';

  const getTotalAmountRecieve = async () => {
    const instantSharePayload = {
      appVersion: globalConst.appVersion,
      probeid: eventDetails.id,
      amount: watchshare,
    };

    const res = await Network.getAddLiquidityShares(instantSharePayload);
    if (res?.data?.success == true) {
      var typeOfPosition = '';
      if (res.data?.positionType != null) {
        typeOfPosition = res.data?.positionType == 'Y' ? 'Yes' : 'No';
      }

      setLiq({
        liquidityShares: res.data?.liquidity_token_count?.toFixed(2) || 0,
        liquidityTokenPrice: res.data?.liquidity_token_price?.toFixed(2) || 0,
        shares: res.data?.position_token?.toFixed(2) || 0,
        positionType: typeOfPosition,
      });

      clearErrors('registerInput');
    } else {
      setError('registerInput', {type: 'custom', message: res?.data?.error});
    }
  };

  let region = userInfo?.region_code ?? "INDIA";

  const onPlaceOrder = async data => {
    if (!userInfo?.isProfileComplete) {
      isMobile() && closeSheet();
      navigation.navigate('Profile');
      return;
    }
    let inputObj = {
      appVersion: globalConst.appVersion,
      probeid: eventDetails.id,
      amount: watchshare,
    };
    if (!isSubmitting) {
      const res = await Network.addLiquidity(inputObj, true);
      orderStatus(res, true, true);
    }
  };

  return (
    <View
      style={[
        {
          // width: Width.width,
          flex: 1,
          alignItems: 'stretch',
          paddingTop: isMobile() ? 0 : 15,
        },
        isMobile() ? {width: Width.width} : null,
      ]}>
      <TitleComponent eventInfo={eventDetails} />
      <View style={{ borderBottomWidth: 0.75, borderBottomColor: globalConfigurableData.borderColor, marginHorizontal: 15 }}>
        <FormTextLabel
          labelStyles={[
            styles.selectedFormTypeBlock,
            globalFontStyle.appFontSubHeading,
          ]}
          label={'Enter Liquidity Details'}
        />
      </View>
      <View
        style={{
          paddingHorizontal: 15,
          paddingVertical: 5,
          justifyContent: 'space-between',
        }}>
        <View style={{...globalFormStyle.tableContainerRow, paddingBottom: 10}}>
          <View>
            <FormTextLabel
              labelStyles={globalFormStyle.fieldLeft}
              label={'Liquidity Amount'}
            />
          </View>

          <Input
            name="currentShare"
            placeholder=""
            control={control}
            rules={{
              required: true,
            }}
            numeric={true}
            variant="default"
            size="default"
          />
        </View>
        {errors?.registerInput?.type === 'custom' && (
          <Text style={globalStyle.errorText}>
            {errors.registerInput.message}
          </Text>
        )}
        <View style={{...globalFormStyle.tableContainerRow, paddingTop: 25}}>
          <View>
            <FormTextLabel
              labelStyles={globalFormStyle.fieldLeft}
              label={'Outcome Shares'}
            />
            <FormTextLabel
              labelStyles={styles.fieldLeft1}
              label={'LP Shares @ each'}
              rest={{
                liquidityShares: liq?.liquidityShares,
                liquidityTokenPrice: liq?.liquidityTokenPrice,
              }}
            />
          </View>

          <Text
            style={{
              color: Colors.black,
              ...globalFontStyle.appFontBody,
            }}>
            {(liq.liquidityShares * liq.liquidityTokenPrice).toFixed(2)}
          </Text>
        </View>
        <View style={{...globalFormStyle.tableContainerRow, paddingTop: 25}}>
          <View>
            <FormTextLabel
              labelStyles={styles.fieldLeft}
              label={
                liq.positionType == ''
                  ? 'Outcome Shares'
                  : `${liq.positionType} Shares`
              }
            />
          </View>

          <Text
            style={{
                color: globalConfigurableData.primaryTextColor1,
              ...globalFontStyle.appFontBody,
            }}>
            {' '}
            {liq.shares}
          </Text>
        </View>
        <View
          style={[
            globalStyle.customBtnParentModalStyle,
            {paddingHorizontal: 0, paddingTop: 30},
          ]}>
          <Button
            variant={isValid ? "primary" : "disabled"}
            onPress={handleSubmit(onPlaceOrder)}
            translate={true}
          >
            Place Order
          </Button>
        </View>
      </View>
    </View>
  );
};

export default AddLiquidity;

const styles = StyleSheet.create({
  infoStyle: {
    width: 12.5,
    height: 12.5,
  },
  selectedFormTypeBlock: {
    paddingHorizontal: 10,
    borderBottomWidth: 2,
    paddingVertical: 10,
    borderBottomColor: Colors.black,
    alignSelf: 'flex-start',
  },
});
